export const Connector = {
	network: 'network',
	livechat: 'livechat',
};
